import img_club_van_50 from "../assets/img/Club van 50.png";
import img_members from "../assets/img/Members only.png";
// import img_free_gift from "../assets/img/Vrije gave.png";

export default function Support() {
  return (
    <div className="content_container responsive_width">
      <header id="doneren">
        <div className="support__container">
          <div className="support__row">
            <div className="center">
              <h3 className="header_title responsive_width">
                Steun onze vereniging
              </h3>
              {/* <div className="header_text responsive_width">TODO</div> */}
            </div>
          </div>
          <div className="aside__support">
            <div className="aside">
              <div className="support__tile">
                <div>
                  <img
                    className="support__tile_image"
                    src={img_club_van_50}
                    alt="demo"
                  ></img>
                  <h2 className="center">Club van 50</h2>
                  <div className="support__text">
                    De Club van 50 bestaat uit een groep donateurs die jaarlijks
                    50 euro doneren aan fanfare Harpe Davids. Het geld wordt
                    besteed aan tastbare zaken binnen de vereniging. Denk
                    hierbij aan instrumenten, hemden, uniformen en het vaandel.
                    Het bestuur stelt normaliter jaarlijks een doel vast.
                    <br />
                    <br />
                    Als lid wordt u uitgenodigd voor diverse activiteiten,
                    concerten en bent u een eregast bij de uitreiking van onze
                    doelen.
                  </div>
                </div>
                <a
                  className="tile_button"
                  href="mailto:secretariaat@harpedavidsbrunssum.net?subject=Club%20van%2050&body=Hallo%2C%0A%0AIk%20zou%20graag%20lid%20worden%20van%20de%20Club%20van%2050.%0A%0A%3Cvul%20hier%20je%20contact%20informatie%20in%3E"
                >
                  <button className="button_primary">Join the club</button>
                </a>
              </div>
            </div>
            <div className="aside">
              <div className="support__tile">
                <div>
                  <img
                    className="support__tile_image"
                    src={img_members}
                    alt="demo"
                  ></img>
                  <h2 className="center">Steunend Lid</h2>
                  <div className="support__text">
                    Wil je onze fanfare een warm hart toedragen, maar zonder
                    actief mee te spelen? Word dan steunend lid! <br />
                    <br />
                    Voor een gereduceerd bedrag per maand draag je bij aan onze
                    vereniging. Jouw steun maakt het mogelijk om concerten,
                    instrumenten en opleidingen te bekostigen.
                  </div>
                </div>
                <a
                  className="tile_button"
                  href="mailto:secretariaat@harpedavidsbrunssum.net?subject=Steunend%20lidmaatschap&body=Hallo%2C%0A%0AIk%20zou%20graag%20steuned%20lid%20worden.%0A%0A%3Cvul%20hier%20je%20contact%20informatie%20in%3E"
                >
                  <button className="button_primary">Steun ons</button>
                </a>
              </div>
            </div>
            {/* <div className="aside">
              <div className="support__tile">
                <img
                  className="support__tile_image"
                  src={img_free_gift}
                  alt="demo"
                ></img>
                <h2 className="center">Vrije gave</h2>
                <div className="support__text">
                  Wil je op een andere manier onze verening helpen? Bedankt,
                  neem contact met ons op!{" "}
                </div>
                <a
                  className="tile_button"
                  href="mailto:penningmeester@harpedavidsbrunssum.net?subject=Vrije%20gave&body=Hallo%2C%0A%0AIk%20zou%20graag%20eenmalig%20doneren.%0A%0A%3Cvul%20hier%20je%20contact%20informatie%20in%3E"
                >
                  <button className="button_primary">Contact</button>
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </header>
    </div>
  );
}
